import React, {Component} from 'react';
import Styles from './style.css';
import {langRegister} from "../../services/langRegister";
import cx from "classnames";
import {salesChannelRegister} from "../../services/salesChannelRegister";
import {dataRegister} from "../../services/dataRegister";

class BoosterHeaderMobile extends Component {

    constructor(props) {
        super(props);
        this.state = {
            menu: false,
            temp_lang: null,
            language: false,
            dropwdown: false,
            market: null,
            temp_market: null,
            languages: []
        };
    };

    componentWillMount() {

    }

    componentDidMount(){
        this.setState({
            lang: this.props.lang,
            market: this.props.market
        }, () => {
            this._updateLang();
            this._updateLanguages();
        })
    }

    componentWillReceiveProps(nextProps, nextState){
        this.setState({
            lang: nextProps.lang,
            market: nextProps.market
        })
    }

    _updateLang(){
        this.setState({
            lang: this.state.lang
        });
    }

    _updateLanguages(){
        let languages = JSON.parse(salesChannelRegister.get('languages'));
        if(Array.isArray(languages)){
            this.setState({languages: languages});
        }
    }

    _openMenu() {
        this.setState({menu: true});
    }

    _closeMenu() {
        this.setState({menu: false});
    }

    _setLang(prop){
        this.setState({lang: prop, dropdown: false}, () => {
            this.props.history.push({
                pathname: '/' + this.state.market + '/' + prop
            });
            window.location.reload(false);
        });
    }

    _terms(value){
        window.open('https://legal.'+dataRegister.domain+"/" + this.state.market + "/" + this.state.lang + "/" + value + "/" + salesChannelRegister.get('name'), '_blank');
    }


    _goapp(){
        if(dataRegister.getDomain() === "devyieldspotter.com"){
            window.location.replace("https://app.devyieldlock.com");
        }else if(dataRegister.getDomain() === "yieldspotter.com"){
            window.location.replace("https://app.yieldlock.com");
        }else{
            window.location.replace("https://app." + dataRegister.getDomain());
        }
    }

    _renderLanguage(lang){
        try{
        let value = "";
        for(let i = 0; i < this.state.languages.length; i++){
            if(this.state.languages[i].code === lang){
                value = this.state.languages[i].names[this.state.lang];
            }
        }
        return value;
        }catch (e) {}
    }

    _home() {

    }

    _renderText(item) {
        return langRegister.get("mobile-menu", item, this.state.lang);
    }

    renderFacebookPageLink(){
        try {
            if(window.location.hostname.indexOf("propertybooster") !== -1){
                return 'https://www.facebook.com/uae.propertybooster'
            }else if(window.location.hostname.indexOf("boostabostad") !== -1){
                return 'https://www.facebook.com/boostabostad'
            }else if(window.location.hostname.indexOf("yieldlock") !== -1){
                return 'https://www.facebook.com/yieldlock'
            }else if(window.location.hostname.indexOf("yieldspotter") !== -1){
                return 'https://www.facebook.com/yieldspotter'
            }else{
                return undefined
            }
        }catch (e) {
            return undefined
        }
    }

    renderInstagramPageLink(){
        try {
            if(window.location.hostname.indexOf("propertybooster") !== -1){
                return 'https://www.instagram.com/uae.propertybooster'
            }else if(window.location.hostname.indexOf("boostabostad") !== -1){
                return 'https://www.instagram.com/boostabostad'
            }else if(window.location.hostname.indexOf("yieldlock") !== -1){
                return 'https://www.instagram.com/yieldlock'
            }else if(window.location.hostname.indexOf("yieldspotter") !== -1){
                return 'https://www.instagram.com/yieldspotter'
            }else{
                return undefined
            }
        }catch (e) {
            return undefined
        }
    }


    renderYieldlock(){
        try {
            return window.location.hostname.indexOf("yieldlock") !== -1
        }catch (e) {
            return false
        }
    };

    renderYieldspotter(){
        try {
            return window.location.hostname.indexOf("yieldspotter") !== -1
        }catch (e) {
            return false
        }
    };

    render() {
        return (
            <div>
                <div className={
                    cx(Styles.menu,
                        {
                            [Styles.menuOpen]: this.state.menu,
                        })
                }>
                    <div className={Styles.menuInner}>
                        {
                            !this.renderYieldspotter() &&
                        <img onClick={() => this._home()} className={Styles.menuInnerLogo}
                             src={salesChannelRegister.get('logo_mobile')}/>
                        }
                        {
                            this.renderYieldspotter() &&
                            <img onClick={() => this._home()} className={Styles.menuInnerLogo}
                                 src={require("../../assets/images/YS_favicon_color_mobile.png")}/>
                        }
                        {
                            (!this.renderYieldlock() && !this.renderYieldspotter()) &&
                            <img onClick={() => this._closeMenu()} className={Styles.menuInnerClose}
                                 src={require("../../assets/images/cross_icon.png")}/>
                        }
                        {
                            (this.renderYieldlock() || this.renderYieldspotter()) &&
                            <img onClick={() => this._closeMenu()} className={Styles.menuInnerClose}
                                 src={require("../../assets/images/cross_icon_yl.png")}/>
                        }
                        <div className={Styles.menuInnerOptions}>
                            <div className={Styles.dropdown}>
                                <select className={Styles.dropdownSelection} value={this.state.lang} onChange={(event) => this._setLang(event.target.value)}>
                                    {
                                        this.state.languages.map((item, key) => {
                                            return(
                                                <option key={key} value={item.code}>{item.names[this.state.lang]}</option>
                                            )
                                        })
                                    }
                                </select>
                                <div className={Styles.dropdownText}>
                                    {this._renderLanguage(this.state.lang)}
                                </div>
                                <img className={Styles.dropdownArrow} src={require("../../assets/images/arrow_grey.svg")}/>
                            </div>

                            <div className={Styles.divider}/>
                            {
                                !this.renderYieldlock() && !this.renderYieldspotter() &&
                                <div onClick={() => this._goapp()} className={Styles.button}>
                                    {this._renderText("item_22")}
                                </div>
                            }
                            {
                                (this.renderYieldlock() || this.renderYieldspotter()) &&
                                <div onClick={() => this._goapp()} style={this.renderYieldlock() || this.renderYieldspotter()?{background: '#00273A'}:{}} className={Styles.button}>
                                    {this._renderText("item_23")}
                                </div>
                            }
                            <div className={Styles.socialIcons}>
                                    <a className={Styles.socialIcon} href={this.renderFacebookPageLink()} target={"_blank"}>
                                        <img className={Styles.socialIconFb}
                                             src={require("../../assets/images/facebook_icon.png")}/>
                                    </a>
                                    <a className={Styles.socialIcon} href={this.renderInstagramPageLink()} target={"_blank"}>
                                        <img className={Styles.socialIconInstagram}
                                             src={require("../../assets/images/instagram_icon.png")}/>
                                    </a>
                                {
                                    false &&
                                    <div className={Styles.socialIcon}>
                                        <img className={Styles.socialIconLinkedIn}
                                             src={require("../../assets/images/linkedin_icon.png")}/>
                                    </div>
                                }
                                {
                                    false &&
                                    <div className={Styles.socialIcon}>
                                        <img className={Styles.socialIconTwitter}
                                             src={require("../../assets/images/twitter_icon.png")}/>
                                    </div>
                                }
                            </div>
                            <div className={Styles.terms}>
                                <span onClick={() => this._terms("terms")}>{this._renderText("item_14")}</span> | <span onClick={() => this._terms("privacy")}>{this._renderText("item_15")}</span> | <span onClick={() => this._terms("acceptance")}>{this._renderText("item_16")}</span>
                            </div>
                            <div style={{width: "100%", height: "200px"}}/>
                        </div>
                    </div>
                </div>
                {
                    this.state.menu &&
                    <div className={Styles.overlay}/>
                }
            </div>
        );
    }
}

export default BoosterHeaderMobile;


// WEBPACK FOOTER //
// ./src/components/booster-header-mobile/component.js